/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */

export type TrainWithMeDataEnumsSurveyKind = typeof TrainWithMeDataEnumsSurveyKind[keyof typeof TrainWithMeDataEnumsSurveyKind];


export const TrainWithMeDataEnumsSurveyKind = {
  Intake: 'Intake',
  CheckIn: 'CheckIn',
  Reassessment: 'Reassessment',
  LeadForm: 'LeadForm',
} as const;
